import React from "react";

export default function QualityControlManagement() {
  return (
    <div className="container py-5">
      <h2 className="fw-bold text-center mb-5 text-danger title split-collab" style={{fontSize: "clamp(1.8rem, 5vw, 3.2rem)"}}>
        
          QUALITY CONTROL MANAGEMENT
        
      </h2>

      <div className="row"  data-sal-delay="150"
        data-sal="slide-up"
        data-sal-duration="800">
        {/* 1. Venue Booking */}
        <div className="col-md-6 mb-4">
          <div className="d-flex align-items-start p-4" style={{ backgroundColor: "#fff8e1", borderRadius: "50px" }}>
            <div className="me-3">
              <div className="rounded-circle d-flex justify-content-center align-items-center" style={{ width: "40px", height: "40px", backgroundColor: "#ff9800" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 24 24"><path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>
              </div>
            </div>
            <div>
              <h5 className="fw-bold text-warning">1. Venue booking</h5>
              <p className="mb-0 small">(MOU, Mail, Correspondence, payments, Audits, reputation, etc)</p>
            </div>
          </div>
        </div>

        {/* 2. Infrastructure */}
        <div className="col-md-6 mb-4">
          <div className="d-flex align-items-start p-4" style={{ backgroundColor: "#ffe6ec", borderRadius: "50px" }}>
            <div className="me-3">
              <div className="rounded-circle d-flex justify-content-center align-items-center" style={{ width: "40px", height: "40px", backgroundColor: "#e91e63" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 24 24"><path d="M9 21H7v-2h2v2zm4-6h-2v2h2v-2zm4-4h-2v2h2v-2z"/><path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h3v-2H5V5h14v14h-3v2h3c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/></svg>
              </div>
            </div>
            <div>
              <h5 className="fw-bold text-danger">2. Infrastructure and Inventory Management</h5>
              <p className="mb-0 small">(Inventory Management)</p>
            </div>
          </div>
        </div>

        {/* 3. Manpower Management */}
        <div className="col-md-6 mb-4">
          <div className="d-flex align-items-start p-4" style={{ backgroundColor: "#e0f7fa", borderRadius: "50px" }}>
            <div className="me-3">
              <div className="rounded-circle d-flex justify-content-center align-items-center" style={{ width: "40px", height: "40px", backgroundColor: "#00bcd4" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 24 24"><path d="M12 12c2.7 0 5-2.3 5-5s-2.3-5-5-5-5 2.3-5 5 2.3 5 5 5zm0 2c-2.7 0-8 1.3-8 4v2h16v-2c0-2.7-5.3-4-8-4z"/></svg>
              </div>
            </div>
            <div>
              <h5 className="fw-bold text-info">3. Manpower Management</h5>
              <p className="mb-0 small">(Training, integrity, replacement, verified, etc.)</p>
            </div>
          </div>
        </div>

        {/* 4. Live Exam Day Management */}
        <div className="col-md-6 mb-4">
          <div className="d-flex align-items-start p-4" style={{ backgroundColor: "#e8eaf6", borderRadius: "50px" }}>
            <div className="me-3">
              <div className="rounded-circle d-flex justify-content-center align-items-center" style={{ width: "40px", height: "40px", backgroundColor: "#3f51b5" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 24 24"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>
              </div>
            </div>
            <div>
              <h5 className="fw-bold text-primary">4. Live Exam Day management</h5>
              <p className="mb-0 small">(includes Command Centre Management & Regional Centers)</p>
            </div>
          </div>
        </div>

        {/* 5. Failover Management */}
        <div className="col-md-6 mb-4">
          <div className="d-flex align-items-start p-4" style={{ backgroundColor: "#ffe6ec", borderRadius: "50px" }}>
            <div className="me-3">
              <div className="rounded-circle d-flex justify-content-center align-items-center" style={{ width: "40px", height: "40px", backgroundColor: "#e91e63" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 24 24"><path d="M17 3H7c-1.1 0-2 .9-2 2v14l7-3 7 3V5c0-1.1-.9-2-2-2z"/></svg>
              </div>
            </div>
            <div>
              <h5 className="fw-bold text-danger">5. Failover Management</h5>
              <p className="mb-0 small">(Admin, Manpower, Infrastructure, Data)</p>
            </div>
          </div>
        </div>

        {/* 6. Post Exam Day Management */}
        <div className="col-md-6 mb-4">
          <div className="d-flex align-items-start p-4" style={{ backgroundColor: "#f3e5f5", borderRadius: "50px" }}>
            <div className="me-3">
              <div className="rounded-circle d-flex justify-content-center align-items-center" style={{ width: "40px", height: "40px", backgroundColor: "#9c27b0" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="white" viewBox="0 0 24 24"><path d="M3 3v18h18V3H3zm16 16H5V5h14v14zM9 9h6v2H9V9zm0 4h6v2H9v-2z"/></svg>
              </div>
            </div>
            <div>
              <h5 className="fw-bold" style={{ color: "#9c27b0" }}>6. Post Exam Day Management</h5>
              <p className="mb-0 small">(Exam Data, Inventory, Payments)</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}